import { Link } from "react-router-dom";

interface BrandLogoProps {
  light?: boolean;
}

export default function BrandLogo({ light = false }: BrandLogoProps) {
  return (
    <Link to="/" className="flex items-center gap-2.5 cursor-pointer group">
      <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-sm transition-transform duration-300 group-hover:rotate-6">
        <i className="ri-heart-3-fill text-xl leading-none"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span
          className={`font-heading text-xl font-extrabold tracking-tight ${
            light ? "text-background-50" : "text-foreground-950"
          }`}
        >
          糖心<span className="text-primary-500">VLGO</span>
        </span>
        <span
          className={`font-label text-[10px] tracking-[0.22em] uppercase mt-0.5 ${
            light ? "text-background-50/70" : "text-foreground-500"
          }`}
        >
          Sweet · Heart
        </span>
      </span>
    </Link>
  );
}